module.exports = __webpack_public_path__ + "static/media/intro.c7266dcc.mp3";